import { Favorite } from './types';

export function getMapsByFavoriteList(list: Favorite[]) {
  const dictionary: Record<number, Favorite> = {};
  const positions = new Map();

  list.forEach((f, index) => {
    dictionary[f.assetId] = f;
    positions.set(f.assetId, index);
  });

  return {
    dictionary,
    positions,
  };
}
